export default {
  computed: {
    firstMorningHour() {
      const hour = this.business.houre_week_morning_open.substring(0, 5)
      if (hour[0] === '0') {
        return hour.substring(1, 5)
      }
      return hour
    },
    lastMorningHour() {
      return this.business.houre_week_morning_close.substring(0, 5)
    },
    firstEveningHour() {
      return this.business.houre_week_afternoone_open.substring(0, 5)
    },
    lastEveninggHour() {
      return this.business.houre_week_afternoone_close.substring(0, 5)
    },
    weekendFirstMorningHour() {
      const hour = this.business.houre_week_end_morning_open.substring(0, 5)
      if (hour[0] === '0') {
        return hour.substring(1, 5)
      }
      return hour
    },
    weekendLastMorningHour() {
      return this.business.houre_week_end_morning_close.substring(0, 5)
    },
    weekendFirstEveningHour() {
      return this.business.houre_week_end_afternoone_open.substring(0, 5)
    },
    weekendLastEveninggHour() {
      return this.business.houre_week_end_afternoone_close.substring(0, 5)
    },
    weekendIsClosed() {
      return this.weekendFirstMorningHour === '0:00'
    },
    hasPause() {
      return this.firstEveningHour !== '00:00'
    },
    weekendHasPause() {
      return this.weekendFirstEveningHour !== '00:00'
    },
    weekdaysTxt() {
      const txt = `Semaine : De ${this.firstMorningHour} à ${this.lastMorningHour}`;

      return !this.hasPause ? txt : `${txt} et de ${this.firstEveningHour} à ${this.lastEveninggHour}`
    },
    weekendsTxt() {
      if (this.weekendIsClosed) {
        return 'Samedi : Fermé'
      }
      const txt = `Samedi : De ${this.weekendFirstMorningHour} à ${this.weekendLastMorningHour}`;

      return !this.weekendHasPause ? txt : `${txt} et de ${this.weekendFirstEveningHour} à ${this.weekendLastEveninggHour}`
    },
  },
}
